<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-06-27 16:19:44
 * @LastEditors: Sephiroth·D·Kid
 * @LastEditTime: 2019-08-02 09:41:11
 * @Description: 关于我们
 -->

<template>
  <div class="about-us-wrapper">
    <div class="banner">
      <img src="https://files.jinr.com/jinr-index/img/about-us.png" alt="" v-show="!isParty" />
      <img src="https://files.jinr.com/jinr-index/img/banner-party.png" alt="" v-show="isParty" />
    </div>
    <div class="content-wrapper">
      <div class="slide-warpper">
        <div
          v-for="(item, index) in navList"
          :key="index"
          class="slide-item"
          :class="{ active: activeIndex === index }"
          @click="routerJump(item, index)"
        >
          <div class="border-line"></div>
          <span>{{ item.meta.title }}</span>
        </div>
      </div>
      <div class="main-view">
        <header-banner :title="title" :isParty="isParty"></header-banner>
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
<script>
import pcRoutes from '@/router/pc-routes.js';
import HeaderBanner from './components/header';
export default {
  name: 'AboutUs',
  components: {
    HeaderBanner
  },
  data() {
    return {
      activeIndex: 0
    };
  },
  computed: {
    navList() {
      return pcRoutes[4].children;
    },
    title() {
      return this.$route.meta.title;
    },
    routerPath() {
      return window.location.href.split('#/')[1];
    },
    isParty() {
      const reg = /\/about-us\/party/;
      return reg.test(this.$route.path);
      // return this.$route.path === '/about-us/party/list';
    }
  },
  watch: {
    $route(to) {
      this.locationRouter(to.path);
    }
  },
  created() {
    this.locationRouter();
  },
  mounted() {
    let head = document.head || document.getElementByTagName('head')[0] || document.documentElement;
    let script = document.createElement('script');
    script.setAttribute('type', 'text/javascript');
    script.setAttribute('src', 'https://s4.cnzz.com/z_stat.php?id=1279001425&web_id=1279001425');
    head.appendChild(script);
    console.log(head);
    script.onload = function() {
      // 执行后续操作。
      console.log('loaded');
    };
  },
  methods: {
    routerJump(route, index) {
      this.activeIndex = index;
      this.$router.push({
        path: route.path,
        name: route.name
      });
    },
    locationRouter(path) {
      const routerPath = path ? path : `/${this.routerPath}`;
      this.navList.forEach((item, index) => {
        const tempStr = routerPath.split('/')[2];
        if (item.path === tempStr) {
          this.activeIndex = index;
        }
      });
    }
  }
};
</script>
<style lang="less" scope>
.about-us-wrapper {
  overflow: hidden;
  .banner {
    position: relative;
    width: 1200px;
    height: 300px;
    margin: 0 auto;
    img {
      height: 100%;
      position: absolute;
      top: 0;
      left: 50%;
      transform: translate(-50%);
    }
  }
  .content-wrapper {
    display: flex;
    width: 1200px;
    margin: 0 auto;
    padding: 18px 0;
    align-items: flex-start;
    overflow: hidden;
  }
  .slide-warpper {
    width: 250px;
    flex-shrink: 0;
    padding: 20px 0;
    margin-right: 14px;
    border-radius: 10px;
    background: #ffffff;
    box-sizing: border-box;
    .slide-item {
      height: 30px;
      font-size: 18px;
      color: #333333;
      line-height: 30px;
      text-align: center;
      margin: 15px 0;
      cursor: pointer;
    }
    .slide-item.active {
      position: relative;
      color: #2c6eff;
      .border-line {
        position: absolute;
        width: 4px;
        height: 30px;
        border-radius: 2px;
        background: #2c6eff;
      }
    }
  }
  .main-view {
    min-height: 324px;
    background: #ffffff;
    border-radius: 10px;
    box-sizing: border-box;
    width: 936px;
  }
}
</style>
